import BossModel from "@/models/BossModel";
import WebsiteCategory from "@/models/WebsiteCategory/WebsiteCategory";
import WebsiteProductTagTypeWebsiteCategory
    from "@/models/WebsiteProduct/Tag/Type/Category/Category";

export default class WebsiteProductTagType extends BossModel {

    /**
     *
     * @type {string}
     */
    static apiUrl = 'website-product/tag/type';

    /**
     *
     * @type {string}
     */
    static entity = 'websiteProductTagTypes';

    static fields() {
        return {
            id: this.number(null).nullable(),
            name: this.attr(null),
            created_at: this.attr(null),
            updated_at: this.attr(null),
            is_hotels: this.boolean(null),
            websiteCategories: this.belongsToMany(WebsiteCategory,WebsiteProductTagTypeWebsiteCategory,'website_product_tag_type_id', 'website_category_id'),
        }
    }

    /**
     *
     * @param params
     * @returns {*}
     */
    static get(params = {}) {
        return this.api()
            .filtered(params.filters)
            .limit(0)
            .with(params.withs)
            .ordered(params.sortBy)
            .appended(params.appends)
            .get();
    }

    /**
     *
     * @returns {*}
     * @constructor
     */
    WebsiteCategories() {
        return this.getRelated('websiteCategories');
    }


    /**
     *
     * @returns {*}
     */
    static fetchAllForSelect() {
        return this.api()
            .limit(0)
            .get(true);
    }
}
